import { InputFormTypes } from '@taxdown/piccolo-web';
import { openLinkInNewTab } from 'Utils/links';

export const model = [
  {
    id: 'rfc',
    label: 'RFC',
    placeholder: 'dg:DGRfc.Rfc.placeholder',
    info: 'dg:DGRfc.Rfc.info',
    name: 'rfc',
    validationType: 'Rfc',
    inputType: 'Base',
    errMsg: 'Dg.rfc.error',
    className: 'input-transform',
    type: InputFormTypes.TEXT,
    validations: {
      required: true,
    },
  },
  {
    id: 'password',
    label: 'Contraseña del SAT',
    hasBorder: false,
    placeholder: 'dg:DGRfc.Password.placeholder',
    description: 'La contraseña con la que entras al portal del SAT',
    info: 'dg:DGRfc.Password.info',
    helpButtonUrl:
      'https://help.taxdown.com.mx/es/articles/7157712-que-es-la-contrasena-del-sat-y-como-la-genero',
    name: 'password',
    onHelpButton: (): void =>
      openLinkInNewTab(
        'https://help.taxdown.com.mx/es/articles/7157712-que-es-la-contrasena-del-sat-y-como-la-genero'
      ),
    showContextual: true,
    contextualLabel: 'información',
    type: InputFormTypes.PASSWORD,
    validationType: 'Regex',
    errMsg: 'Dg.password.error',
    autoFocus: true,
    validations: {
      required: true,
      regex: '^[a-zA-Z0-9]{8,}$',
    },
  },
];
